import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { AppMaterialModule } from '../appMaterial/app-material.module';
import { TimezoneComponent } from './timezone.component';

@NgModule({
  imports: [CommonModule, AppMaterialModule, FormsModule, ReactiveFormsModule],
  exports: [TimezoneComponent],
  declarations: [TimezoneComponent],
  providers: []
})
export class TimezoneModule {}
